import {BaseModel} from "../base.model";

export interface Rate extends BaseModel {
  
}

export const defaultRate: Readonly<Rate> = {};